/**
 * Meldungsdialog der View-Seiten — Port des `<SfDialog>`-Blocks mit `DialogCaption`
 * als Kopfzeile und `DialogText` als Inhalt.
 */

import type { ReactNode } from 'react';

import { Dialog } from '@/components/ui';

export interface MessageDialogProps {
  open: boolean;
  onClose(): void;
  caption: string;
  text: ReactNode;
  /** `450px` bei Container und Bestellposition, `650px` bei Rechnung. */
  width?: string;
}

export function MessageDialog(props: MessageDialogProps) {
  return (
    <Dialog
      open={props.open}
      onClose={() => {
        props.onClose();
      }}
      header={props.caption}
      width={props.width}
    >
      {props.text}
    </Dialog>
  );
}

export default MessageDialog;
